export default "__VITE_ASSET__CkZ5BM____"